import { render, staticRenderFns } from "./CurrencyMaster.vue?vue&type=template&id=20f10c7c"
import script from "./CurrencyMaster.vue?vue&type=script&lang=js"
export * from "./CurrencyMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports